<template>
  <div v-if="!item.hidden">
    <div class="noChildren" v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      ">
      <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }" @click="reload">
        <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
          <item :isActive="isActive(item)" :activeMenu="activeMenu" :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" :activeIcon="onlyOneChild.meta.activeIcon || (item.meta && item.meta.activeIcon)" :title="onlyOneChild.meta.title" />
        </app-link>
      </el-menu-item>
    </div>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <!-- <app-link v-if="item.redirect" :to="resolvePath(item.redirect)">
        <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
        />
        </template>
      </app-link> -->
      <template slot="title">
        <app-link v-if="item.redirect && item.redirect !== 'noRedirect'" :to="resolvePath(item.redirect)">
          <item :isActive="isActive(item)" :activeMenu="activeMenu" v-if="item.meta" :icon="item.meta && item.meta.icon" :activeIcon="item.meta && item.meta.activeIcon" :title="item.meta.title" />
        </app-link>

        <item v-else :isActive="isActive(item)" :activeMenu="activeMenu" :icon="item.meta && item.meta.icon" :activeIcon="item.meta && item.meta.activeIcon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import store from "@/store";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    activeMenu: {
      type: String|Number,
      // required: true,
    },
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {
      time: ""
    };
  },
  computed:{
    // isActive(){
    //   console.log(this.$route)
    //   if(this.$route.path==this.activeMenu){
    //     return true
    //   }
    //   return false
    // },
  },
  methods: {
    isActive(item){
      // console.log(this.$route)
      // console.log(item)
      // console.log(this.activeMenu)
      let arr=this.$route.path.split('/')
      // console.log(arr[2])
      if(item.name==arr[2]){
        // console.log(true)
        return true
      }
      return false
    },
    reload(item) {
      // console.log(item)
      // store.commit('settings/changeIsrefresh',true)
    },
    hasOneShowingChild(children = [], parent) {
      // console.log(parent);

      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          if (item.display) {
            return true;
          }
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      // console.log(routePath);
      // console.log(this.activeMenu)
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      const currentRoutes = this.$store.state.permission.currentRoutes;
      if (currentRoutes && currentRoutes.path) {
        return path.resolve(currentRoutes.path, this.basePath, routePath);
      }
    },
  },
};
</script>
